import React, { useState } from 'react';
import { Confirmation } from './modals/common';
import { messageUtility } from '../utilities/messageUtility';
import _dialogLoader from '../utilities/dialogLoader';

export const FormCloseConfirmDialog = props => {
  const { formClose } = props.dialog || {};

  return (
    <Confirmation
      visible={true}
      title={messageUtility.getMessage('I-000-025')}
      message={messageUtility.getMessage('I-000-confirmCloseEditWindow')}
      confirmButtonText={messageUtility.getMessage('I-000-017')}
      cancelButtonText={messageUtility.getMessage('I-000-008')}
      isNegative={true}
      onConfirm={formClose}
      onCancel={() => _dialogLoader.close()}
    />
  );
};

export const RemoveConfirmDialog = props => {
  const { remove } = props.dialog || {};

  return (
    <Confirmation
      visible={true}
      title={messageUtility.getMessage('I-000-093')}
      message={messageUtility.getMessage('I-000-094')}
      confirmButtonText={messageUtility.getMessage('I-000-018')}
      cancelButtonText={messageUtility.getMessage('I-000-008')}
      isNegative={true}
      onConfirm={remove}
      onCancel={() => _dialogLoader.close()}
    />
  );
};

export const ApplyCancelConfirmDialog = props => {
  const { applyCancel } = props.dialog || {};

  return (
    <Confirmation
      visible={true}
      title={messageUtility.getMessage('I-000-095')}
      message={messageUtility.getMessage('I-000-096')}
      confirmButtonText={messageUtility.getMessage('I-000-097')}
      cancelButtonText={messageUtility.getMessage('I-000-008')}
      isNegative={true}
      onConfirm={applyCancel}
      onCancel={() => _dialogLoader.close()}
    />
  );
};

export const DuplicateWarnDialog = props => {
  const { moveDuplicateApplyDetail } = props.dialog || {};

  return (
    <Confirmation
      visible={true}
      title={messageUtility.getMessage('I-000-098')}
      message={messageUtility.getMessage('I-000-099')}
      confirmButtonText={messageUtility.getMessage('I-000-053')}
      cancelButtonText={messageUtility.getMessage('I-000-008')}
      onConfirm={moveDuplicateApplyDetail}
      onCancel={() => _dialogLoader.close()}
    />
  );
};

export const DuplicateApprovedDialog = props => {
  const { moveDuplicateApplyDetail } = props.dialog || {};

  return (
    <Confirmation
      visible={true}
      title={messageUtility.getMessage('I-000-140')}
      message={messageUtility.getMessage('I-000-141')}
      confirmButtonText={'代行先一覧'}
      cancelButtonText={messageUtility.getMessage('I-000-008')}
      onConfirm={moveDuplicateApplyDetail}
      onCancel={() => _dialogLoader.close()}
    />
  );
};

export const ApplyConfirmDialog = props => {
  const { apply } = props.dialog || {};
  const [checked, setChecked] = useState(false);
  const handleAgreement = () => setChecked(!checked);

  const renderMessage = () => {
    return (
      <div className='ApplyConfirmDialog__body'>
        <div className='ApplyConfirmDialog__message'>
          代行登録申請には、下記の内容をご確認いただき、同意していただく必要があります。
        </div>
        <ul className='ApplyConfirmDialog__message--list'>
          <li className='ApplyConfirmDialog__message--list-item'>
            Buildee上に掲載されている最新の覚書テンプレートを利用しており、かつ本文部分を変更していないこと。
            <br />
            &ensp;&emsp;※フッターにOBG-001の記載がないテンプレートは、2022年07月01日以降はご利用いただけません。
          </li>
          <li className='ApplyConfirmDialog__message--list-item'>
            覚書の内容確認のため、覚書の当事者に連絡することがあります。
          </li>
          <li className='ApplyConfirmDialog__message--list-item'>
            添付した覚書は申請者が保管すること。
          </li>
          <li className='ApplyConfirmDialog__message--list-item'>
            取得した情報は覚書記載の目的以外に利用しないこと。
          </li>
          <li className='ApplyConfirmDialog__message--list-item'>
            覚書は正規の手順を踏んで締結しており、内容に虚偽がないこと。
          </li>
        </ul>
        <div className='ApplyConfirmDialog__message'>
          申請することによって、リバスタへ申請依頼が送られます。
          <br />
          この内容で申請してよろしいですか？
        </div>
        <div className='ApplyConfirmDialog__checkbox'>
          <label className='checkbox'>
            <input
              name='checkbox'
              type='checkbox'
              disabled={false}
              checked={checked}
              onChange={handleAgreement}
            />
            <i className='i-square i-3x' />
            覚書の取り扱いに同意する
          </label>
        </div>
      </div>
    );
  };
  return (
    <Confirmation
      rootClassName={'ApplyConfirmDialog'}
      visible={true}
      title={messageUtility.getMessage('I-000-100')}
      message={renderMessage()}
      confirmButtonText={messageUtility.getMessage('I-000-102')}
      cancelButtonText={messageUtility.getMessage('I-000-008')}
      onConfirm={apply}
      onCancel={() => _dialogLoader.close()}
      disabledConfirmButton={!checked}
    />
  );
};



// WEBPACK FOOTER //
// ./src/components/AgencyRegistrationApplicationDialog.jsx